import { DivX } from '@dui';
import { classNames } from '@vkontakte/vkjs';
import styles from './AboutSection.module.css';

interface AboutSectionProps {
  /** Заголовок **/
  title: React.ReactNode;
  /** Подзаголовок **/
  subtitle: React.ReactNode;
  /** Текст после анимации **/
  text: React.ReactNode;
  /** ссылка на изображение **/
  imageUrl: string;
  className?: string;
}

/** Раздел "О конкурсе" **/
export function AboutSection(props: AboutSectionProps) {
  const { title, subtitle, text, imageUrl, className } = props;

  return (
    <div id="about" className={classNames(styles.root, className)}>
      {title}

      <DivX className={styles.wrapperText}>{subtitle}</DivX>

      <div className={styles.avatarsLine}>
        {/* нужно два изображения, чтоб было зацикливание анимации */}
        {[1, 2].map((item) => (
          <img key={item} src={imageUrl} alt="" loading="lazy" />
        ))}
      </div>

      <DivX className={styles.wrapperShortText}>{text}</DivX>
    </div>
  );
}
